import { makeAutoObservable, runInAction } from "mobx";
import { TicketService } from "../../services/ticket-service";
import IShortTicket from "../../models/ticket";
import { message } from "antd";
import FilesService from "../../services/files-service";
import TicketItemStore from "./ticket-item";
import Subjects from "../../models/subjects";
import { IShortStudent } from "../../models/student";
import { StudentService } from "../../services/student-service";
import Pagination from "../../models/pagination";

export default class TicketList {

    data: TicketItemStore[];
    currentPage: number;
    totalCount: number;
    studentList: IShortStudent[];

    filesService: FilesService;
    ticketService: TicketService;
    studentService: StudentService;
    subject: Subjects;

    loading: boolean;

    constructor(subject: Subjects) {

        this.data = [];
        this.currentPage = 1;
        this.totalCount = 0;
        this.studentList = [];
        this.filesService = new FilesService();
        this.ticketService = new TicketService(subject);
        this.studentService = new StudentService(subject);
        this.subject = subject;
        this.loading = false;

        makeAutoObservable(this);
    }

    loadList(page: number): void {

        try {

            this.loading = true;
            
            var params = {
                page: (page - 1),//antd starts pagination from 1, Spring from 0 
                size: Pagination.PAGE_SIZE
            };
            const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

            this.ticketService.loadList(
                urlParams,
                data => {
                    this.data = (data['content'] as IShortTicket[]).map((item) => new TicketItemStore(item, this.subject));
                    this.totalCount = data['totalElements'];
                    this.currentPage = page;
                    this.loading = false;
                }
            );

        } catch (error) {
            runInAction(() => { message.error(error); this.loading = false; });
        }
    }

    loadStudentList(): void {

        try {

            this.studentService.loadShortList(
                data => {
                    this.studentList = data as IShortStudent[];
                }
            );

        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }

    getUrl(fileId: string): string {
        return this.filesService.getFileUrl(fileId);
    }

    getItemIndex(indx: number): number {
        return indx + (this.currentPage - 1) * Pagination.PAGE_SIZE;
    }
}